export default {
    state: {
        token: '',
        avatar: 'http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLf5tnz2N6KnMamKCA3Vnb4a7B6VNMo9g9JOkScJgI6rR5cVzbGyy8V9c9uxYuTPB2ictZqjtbd8ZA/132',
        name: '胡萝卜炖肉'
    },
    mutations: {
        setUserToken (state, value) {
            state.token = value
        }
    },
    actions: {

    }
}
